import AccountPage from './account-page'

export default AccountPage